import { ELECTRON_MODE, KioskAssetsSize } from "@constants";
import { useSnapshot } from "valtio";

import { shallowEqual, useSelector } from "react-redux";

import {
    getImageByLanguage,
    getRowsColumnsDesign,
    getSuspendedItem,
    getUrlImage,
} from "@components/OrderTaking/Helpers";
import { memoizedSelectedProducts } from "@components/OrderTaking/Store/feature";

import { kioskStore } from "@pages/Kiosk/store";

export const getVisibleItems = (
    listProducts,
    listAdditionnalItems,
    activeCategory,
    selectedSaleModeOrderTaking,
    isWorkFlow,
    currentWorkflow,
    isAdditionalSale,
    additionalSale,
    design,
    activeStepTags
) => {
    const { isPrm } = useSnapshot(kioskStore);
    const products =
        listProducts !== undefined
            ? getWorkFlowProductsByActiveTags(activeStepTags, listProducts)
            : listAdditionnalItems !== undefined
            ? listAdditionnalItems
            : useSelector((state) =>
                  memoizedSelectedProducts(state, activeCategory)
              );

    const { isImageResized } = useSelector(
        (state) => state.orderSlice,
        shallowEqual
    );

    const visibleItems = [];
    const visibleProducts = products.filter(
        (product) => product?.KioskVisibility[selectedSaleModeOrderTaking]
    );

    const gridData = () => {
        if (isPrm) {
            return { nbrRows: 2, nbrColumn: 2, isAutoDesign: true };
        }
        let gridSystem = isWorkFlow
            ? currentWorkflow.workflow[currentWorkflow.index].design
            : isAdditionalSale
            ? additionalSale.design
            : design;
        if (gridSystem.isAutoDesign) {
            gridSystem = getRowsColumnsDesign(visibleProducts.length);
        }
        return gridSystem;
    };
    const gridSystem = gridData();
    visibleProducts.forEach((product) => {
        const isSuspended =
            product?.type !== "basic_composition" &&
            getSuspendedItem(product?.suspSale);
        const type = product.isRedirect ? "items" : product.type;
        let productImage = getImageByLanguage(product?.url_image, type);

        const heightOfImage =
            KioskAssetsSize[gridSystem.nbrRows + "_" + gridSystem.nbrColumn]
                .height;
        const widthOfImage =
            KioskAssetsSize[gridSystem.nbrRows + "_" + gridSystem.nbrColumn]
                .width;

        if (process.env.REACT_APP_MODE === ELECTRON_MODE && isImageResized) {
            const url =
                KioskAssetsSize[gridSystem.nbrRows + "_" + gridSystem.nbrColumn]
                    .url;

            productImage = getUrlImage(productImage, url);
        }

        visibleItems.push({
            ...product,
            isSuspended,
            image: productImage,
            showProductIcons: Boolean(gridSystem?.nbrColumn === 5),
            heightOfImage,
            widthOfImage,
        });
    });
    const largeFont =
        gridSystem.nbrRows >= 3 || gridSystem.nbrColumn === 5 ? "larger" : "";

    document.documentElement.style.setProperty("--large-font", largeFont);

    return { visibleItems, gridSystem };
};

const getWorkFlowProductsByActiveTags = (activeTags, products) => {
    if (!activeTags || activeTags.length === 0) {
        return products;
    }

    const allowedIuuds = new Set(activeTags.flatMap((tag) => tag.itemsIuud));

    return products.filter((product) => allowedIuuds.has(product.iuud));
};
